// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { KeepAliveContext,useKeepOutlets, MaxTabsLayout } from './context';
export { dropByCacheKey, refreshTab, closeTab, closeAllTabs, replaceTab, replaceTabByRouter, swapTab, moveTab, moveBeforeTab, moveAfterTab, getTabList, triggerCloseBorEvent, addPlaceholderTab } from './support';
